
export const HOME_PAGE = "Landing-page";
//export const img = "https://d9nwtjplhevo0.cloudfront.net/orasi/client/resources/orasiv1/images/";
export const compress = "auto=compress,format";
export const imgmiddle = "orasi/client/resources/orasiv1/images/";
export const imgcommon = "orasi/common/images/";
export const imgix = "https://d9nwtjplhevo0.cloudfront.net/";
